/* Nr. 1 (M78): oeffnet den Dialog der EU-Mitteilung zur gesetzlichen Gewaehrleistung auch fuer
   Ausloeser, die erst nach dem Laden entstehen (Warenkorb-Schublade wird bei jeder Aenderung neu
   gerendert, Schnellansicht laedt nach; basic-modal bindet seine Ausloeser nur beim Einhaengen).
   Bereits gebundene Ausloeser oeffnen den Dialog selbst; dann ist er hier schon offen.
   Escape schliesst nur den Dialog und nicht zusaetzlich Schublade oder Schnellansicht darunter.
   Ausloeser in der offenen Warenkorb-Schublade: erst schliesst die Schublade, dann oeffnet der Dialog;
   nach dem Schliessen des Dialogs geht die Schublade wieder auf (am Handy verdeckte die Schublade
   sonst den Dialog, Rueckmeldung Justin 09.10.2026).
   Geladen von snippets/lc-gewaehrleistung.liquid, nur in EU- und EWR-Laendern.
   Rueckweg: Haken in layout/theme.liquid entfernen; die Datei kann liegen bleiben. */
(function () {
  /* Doppelgang-Schutz ueber ein Attribut statt ueber einen weiteren globalen Namen (Konvention 4.1) */
  var wurzel = document.documentElement;
  if (wurzel.hasAttribute('data-lc-gew-js')) return;
  wurzel.setAttribute('data-lc-gew-js', '');

  var NR = '1';

  /* Messereignis nach Konvention 4.5: gleiche Logik wie nbMessen im Konfigurator, jeder Weg in try/catch */
  window.lcMessen = window.lcMessen || function (name, daten) {
    try { if (typeof window.hj === 'function') window.hj('event', name); } catch (e) { /* Hotjar darf nie blockieren */ }
    try {
      if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
      window.dataLayer.push(Object.assign({ event: name, lc_nr: NR }, daten || {}));
    } catch (e) { /* dataLayer darf nie blockieren */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, Object.assign({ lc_nr: NR }, daten || {}));
      }
    } catch (e) { /* Shopify-Analytics darf nie blockieren */ }
  };

  /* lcMessen gewinnt beim ersten Anlegen (andere lc-Dateien laden auf Produktseiten frueher und tragen
     ihre eigene Nummer im Helfer). Deshalb lc_nr immer im Aufruf mitgeben. */
  function messen(name, daten) {
    try { window.lcMessen(name, Object.assign({ lc_nr: NR }, daten || {})); } catch (e) { /* Messen darf nie blockieren */ }
  }

  function dialog() {
    return document.getElementById('LcGewaehrleistungModal');
  }

  /* Schublade: Die Schublade wird erst geschlossen, dann oeffnet der Dialog. Laeuft in der
     Erfassungsphase, damit ein beim Laden gebundener Ausloeser (basic-modal bindet seine Ausloeser
     direkt) den Dialog nicht schon ueber der offenen Schublade oeffnet. Nach dem Dialog setzt die
     Komponente den Fokus auf das Warenkorb-Symbol zurueck; die Schublade oeffnet erst danach
     (setTimeout) wieder und holt den Fokus dann zu sich. */
  var schubladeWieder = null;
  var ausstehend = null;

  function warenkorbSymbol(schublade) {
    var kandidaten = document.querySelectorAll('[aria-controls="' + schublade.id + '"]');
    for (var i = 0; i < kandidaten.length; i++) {
      if (!schublade.contains(kandidaten[i])) return kandidaten[i];
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-lc-gew-open]') : null;
    if (!t) return;
    var schublade = t.closest('cart-drawer');
    var m = dialog();
    if (!schublade || !schublade.open || typeof schublade.hide !== 'function' || !m || typeof m.show !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    if (m.hasAttribute('open')) return;
    if (ausstehend) return;
    var platz = t.getAttribute('data-lc-gew-platz') || '';
    var symbol = warenkorbSymbol(schublade);
    var auftrag = { abbruch: false };
    ausstehend = auftrag;
    var erledigt = false;
    var oeffnen = function () {
      if (erledigt) return;
      erledigt = true;
      if (ausstehend === auftrag) ausstehend = null;
      /* Escape waehrend des Schliessens oder die Schublade ist inzwischen wieder offen: nichts oeffnen */
      if (auftrag.abbruch || schublade.open || m.hasAttribute('open')) return;
      try { m.show(symbol); } catch (err) { return; /* Dialog darf nie blockieren */ }
      if (m.hasAttribute('open')) {
        schubladeWieder = { schublade: schublade, symbol: symbol };
        messen('lc_gewaehrleistung_geoeffnet', { platz: platz });
      }
    };
    try {
      var warten = schublade.hide();
      if (warten && typeof warten.then === 'function') warten.then(oeffnen, oeffnen);
      else oeffnen();
    } catch (err) {
      oeffnen();
    }
    /* Sicherung, falls das Ende der Schliess-Animation nicht gemeldet wird */
    setTimeout(oeffnen, 900);
  }, true);

  /* Nach dem Schliessen des Dialogs die Schublade wieder oeffnen (nur wenn wir sie geschlossen haben) */
  document.addEventListener('modal:handleAfterHide', function (e) {
    var m = dialog();
    if (!m || e.target !== m || !schubladeWieder) return;
    var w = schubladeWieder;
    schubladeWieder = null;
    /* Nach dem bereits geplanten removeTrapFocus des Dialogs (setTimeout in handleAfterHide) oeffnen */
    setTimeout(function () {
      try {
        var mm = dialog();
        if (mm && mm.hasAttribute('open')) return;
        if (w.schublade.isConnected && !w.schublade.open && typeof w.schublade.show === 'function') w.schublade.show(w.symbol);
      } catch (err) { /* Schublade darf nie blockieren */ }
    }, 30);
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-lc-gew-open]') : null;
    if (!t) return;
    var m = dialog();
    if (!m) return;
    var platz = t.getAttribute('data-lc-gew-platz') || '';
    /* Die Komponente hat ihren Ausloeser-Klick evtl. schon verarbeitet (open gesetzt); sonst oeffnen wir hier */
    if (typeof m.show === 'function' && !m.hasAttribute('open')) {
      e.preventDefault();
      m.show(t);
    }
    messen('lc_gewaehrleistung_geoeffnet', { platz: platz });
  });

  /* Escape: nur den Dialog schliessen. Laeuft in der Erfassungsphase vor den Escape-Hoerern von
     Schublade und Schnellansicht (die hoeren am document auf keyup). */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    /* Escape, waehrend die Schublade fuer den Dialog schliesst: Dialog nicht mehr oeffnen */
    if (ausstehend) ausstehend.abbruch = true;
    var m = dialog();
    if (!m || !m.hasAttribute('open')) return;
    e.stopPropagation();
    if (typeof m.hide === 'function') m.hide();
  }, true);
})();
